module.exports = __webpack_public_path__ + "img/burger.d9cdc492.svg";